<div class="bounce" [ngClass]="type">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
<div class="content" [ngClass]="type">
    <ng-content ></ng-content>
</div>



